import { HStack } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

const ActionButtonsForEditOrders = ({
  cancelChange,
  amendChanges,
  disabled,
}: {
  cancelChange: () => void;
  amendChanges: () => void;
  disabled: boolean;
}) => {
  return (
    <HStack horizontalAlignment="end" margin="16px" gap="8px" data-e2e="action-buttons-container">
      <button type="button" className="btn btn-flat-secondary" data-e2e="cancel-btn" onClick={cancelChange}>
        <FormattedMessage id="order.result.cancelChange" />
      </button>
      <button
        type="button"
        className="btn btn-info ms-2"
        data-e2e="save-btn"
        disabled={disabled}
        onClick={amendChanges}
      >
        <FormattedMessage id="order.result.saveChanges" />
      </button>
    </HStack>
  );
};

export default ActionButtonsForEditOrders;
